module.exports = __webpack_public_path__ + "static/img/3.50ad6e2e.png";